import { GridViewType } from '../../../../shared/components/grid/grid-config';
import { UserDetail } from '../../../admin/admin.model';
import { createPortalAccountsActions } from './customer-details-portal-accounts-actions';

export const CustomerPortalAccountsConfig: GridViewType<UserDetail> = {
  enableColumnFilters: true,
  columns: [
    {
      code: 'actions',
      isActionColumn: true,
      actions: createPortalAccountsActions(),
    },
    {
      code: 'userId',
      label: 'User Name',
      filterType: 'select',
    },
    {
      code: 'firstName',
      label: 'First Name',
      filterType: 'select',
    },
    {
      code: 'lastName',
      label: 'Last Name',
      filterType: 'select',
    },
    {
      code: 'emailAddress',
      label: 'Email Address',
      filterType: 'select',
    },
  ],
};
